import React, { useState } from "react";
import { Pressable, ScrollView, StyleSheet, Text, View } from "react-native";
import { useNavigation } from "@react-navigation/native";
import ReportGoodNewsCarousel from "./ReportGoodNewsCarousel";
import ReportModalSheet from "./ReportModalSheet";
import { SectionHeading } from "./ReportCategoryShared";
import {
  BookIcon,
  DangerIcon,
  DoneIcon,
  ExtensionIcon,
  FlagIcon,
  Heart2Icon,
  InfoCircleIcon,
  ProfileTickIcon,
  StarRoundIcon,
  ThumbUpIcon,
  XIcon,
} from "../assets/icons";

function deriveCompetencyData(statistic, period) {
  const materials = (statistic?.summary_materials || [])
    .filter((item) => item.periode === period)
    .map((item) => ({
      ...item,
      indicators: (item.indicators || []).map((indicator) => ({
        ...indicator,
        category: item.material,
      })),
    }));
  const indicators = materials.flatMap((item) => item.indicators);
  const totalIndicators = materials.reduce(
    (total, item) => total + (Number(item.total_indicator) || 0),
    0,
  );
  const passed = materials.reduce(
    (total, item) => total + (Number(item.passed_indikator) || 0),
    0,
  );
  const failed = materials.reduce(
    (total, item) => total + (Number(item.failed_indicator) || 0),
    0,
  );
  const pending = materials.reduce(
    (total, item) => total + (Number(item.pending_indicator) || 0),
    0,
  );
  const progress = [
    {
      key: "passed",
      label: "Indikator yang sudah tercapai",
      count: passed,
      color: "#48B920",
    },
    {
      key: "failed",
      label: "Indikator yang belum tercapai",
      count: failed,
      color: "#CB494B",
    },
    {
      key: "unrated",
      label: "Indikator yang belum dinilai",
      count: pending,
      color: "#999999",
    },
  ].map((item) => ({
    ...item,
    percentage: totalIndicators
      ? Math.ceil((item.count / totalIndicators) * 100)
      : 0,
  }));
  const sortedIndicators = [...indicators].sort(
    (a, b) => Number(b.value) - Number(a.value),
  );
  const positive = sortedIndicators
    .filter((item) => Number(item.value) >= 2)
    .slice(0, 3);
  const support = [...sortedIndicators]
    .reverse()
    .filter((item) => Number(item.value) < 2)
    .slice(0, 3);
  const featuredCompetencies = [];
  // {
  //   name: item.material,
  //   indicators: Number(item.total_indicator) || 0,
  //   percentage: item.total_indicator
  //     ? Math.ceil(((Number(item.passed_indikator) || 0) * 100) / item.total_indicator)
  //     : 0,
  // }
  materials.map((m) => {
    let chosenIndicaator = 0;
    let totalChosenInticatorValue = 0;
    m.indicators?.map((item) => {
      if (item.value > 0) {
        chosenIndicaator += 1;
        totalChosenInticatorValue += parseInt(item.value);
        console.log(m.material, item.value);
      }
    });
    featuredCompetencies.push({
      name: m.material,
      indicators: chosenIndicaator,
      percentage: chosenIndicaator
        ? Math.ceil((totalChosenInticatorValue / (chosenIndicaator * 3)) * 100)
        : 0,
    });
  });

  return {
    totalCompetencies: statistic?.materials?.length ?? materials.length,
    totalIndicators,
    progress,
    featuredCompetencies,
    topIndicators: { positive, support },
    carouselData: {
      positive: positive.length ? [{ name: positive[0].name }] : [],
      attention: support.length ? [{ name: support[0].name }] : [],
    },
    materialGroups: materials.map((item) => ({
      name: item.material,
      indicators: item.indicators,
    })),
  };
}

function SummaryTotalRow({ Icon, label, value }) {
  return (
    <View style={styles.summaryRow}>
      <View style={styles.summaryIcon}>
        <Icon width={18} height={18} stroke="#FFFFFF" customColor="#FFFFFF" />
      </View>
      <Text style={styles.summaryLabel}>{label}</Text>
      <Text style={styles.summaryValue}>{value}</Text>
    </View>
  );
}

function ProgressStatusRow({ item, isLast, total }) {
  return (
    <View style={[styles.progressRow, isLast && styles.lastProgressRow]}>
      <View
        style={[styles.progressStatusIcon, { backgroundColor: item.color }]}
      >
        {item.key === "passed" ? (
          <DoneIcon width={20} height={20} customColor="#FFFFFF" />
        ) : item.key === "failed" ? (
          <XIcon width={20} height={20} customColor="#FFFFFF" />
        ) : (
          <InfoCircleIcon width={21} height={20} customColor="#FFFFFF" />
        )}
      </View>
      <View style={styles.progressCopy}>
        <Text style={styles.progressLabel}>{item.label}</Text>
        <Text style={styles.progressCount}>
          {item.count} dari {total}
          <Text style={styles.progressPercentage}> • {item.percentage}%</Text>
        </Text>
      </View>
      <View style={styles.progressTrack}>
        <View
          style={[
            styles.progressFill,
            { width: `${item.percentage}%`, backgroundColor: item.color },
          ]}
        />
      </View>
    </View>
  );
}

function CompetencyScoreRow({ item }) {
  return (
    <View style={styles.competencyScoreRow}>
      <View style={styles.competencyCopy}>
        <Text style={styles.competencyName}>{item.name}</Text>
        <Text style={styles.competencyCount}>{item.indicators} Indikator</Text>
      </View>
      <View style={styles.competencyScoreColumn}>
        <Text style={styles.competencyPercentage}>{item.percentage}%</Text>
        <View style={styles.competencyTrack}>
          <View
            style={[styles.competencyFill, { width: `${item.percentage}%` }]}
          />
        </View>
      </View>
    </View>
  );
}

function TopIndicatorRow({ item, isLast, attention }) {
  return (
    <View
      style={[styles.topIndicatorRow, isLast && styles.lastTopIndicatorRow]}
    >
      <View style={styles.topIndicatorChips}>
        <View style={styles.topCategoryChip}>
          <Heart2Icon customColor="#999999" />
          <Text style={styles.topCategoryText}>{item.category}</Text>
        </View>
        <View
          style={[
            styles.topStatusChip,
            attention ? styles.supportStatusChip : styles.bestStatusChip,
          ]}
        >
          <FlagIcon
            width={13}
            height={13}
            customColor={attention ? "#D84343" : "#48B920"}
          />
          <Text
            style={[
              styles.topStatusText,
              attention && styles.supportStatusText,
            ]}
          >
            {item.label}
          </Text>
        </View>
      </View>
      <Text style={styles.topIndicatorDescription}>{item.name}</Text>
    </View>
  );
}

function TopIndicators({ items, onSeeAll }) {
  const [mode, setMode] = useState("positive");
  const attention = mode === "support";
  const indicators = items[mode];

  return (
    <View style={styles.card}>
      <SectionHeading
        Icon={ExtensionIcon}
        title="TOP 3 Indikator"
        actionLabel="Lihat Semua"
        onAction={onSeeAll}
      />
      <View style={styles.segments}>
        <Pressable
          accessibilityRole="button"
          accessibilityState={{ selected: !attention }}
          onPress={() => setMode("positive")}
          style={[styles.segment, !attention && styles.bestSegmentActive]}
        >
          <ThumbUpIcon
            width={22}
            height={22}
            customColor={!attention ? "#48B920" : "#151515"}
          />
          <Text
            style={[styles.segmentText, !attention && styles.bestSegmentText]}
          >
            Indikator{"\n"}Terbaik
          </Text>
          {!attention && (
            <View style={[styles.segmentUnderline, styles.bestUnderline]} />
          )}
        </Pressable>
        <Pressable
          accessibilityRole="button"
          accessibilityState={{ selected: attention }}
          onPress={() => setMode("support")}
          style={[styles.segment, attention && styles.supportSegmentActive]}
        >
          <DangerIcon
            width={22}
            height={22}
            fill={attention ? "#D84343" : "#151515"}
          />
          <Text
            style={[styles.segmentText, attention && styles.supportSegmentText]}
          >
            Perlu{"\n"}Bimbingan
          </Text>
          {attention && (
            <View style={[styles.segmentUnderline, styles.supportUnderline]} />
          )}
        </Pressable>
      </View>
      {indicators.map((item, index) => (
        <TopIndicatorRow
          key={`${item.category}-${index}`}
          item={item}
          attention={attention}
          isLast={index === indicators.length - 1}
        />
      ))}
    </View>
  );
}

export default function ReportCompetencyContent({
  statistic,
  period,
  reportId,
  mode,
}) {
  const navigation = useNavigation();
  const [competenciesOpen, setCompetenciesOpen] = useState(false);
  const data = deriveCompetencyData(statistic, period);
  const openAllIndicators = () =>
    navigation.navigate("ReportIndicatorDetail", {
      id: reportId,
      mode,
      period,
      reportType: "materials",
      indicatorGroups: data.materialGroups,
      showAllIndicators: true,
    });

  return (
    <View style={styles.content}>
      <View style={styles.card}>
        <SectionHeading
          Icon={BookIcon}
          title="Pencapaian Akademik"
          actionLabel="Lihat Semua"
          onAction={openAllIndicators}
        />
        <View style={styles.divider} />
        <SummaryTotalRow
          Icon={ProfileTickIcon}
          label="Total Kompetensi Unggulan"
          value={data.totalCompetencies}
        />
        <SummaryTotalRow
          Icon={StarRoundIcon}
          label="Total Indikator"
          value={data.totalIndicators}
        />
        <View style={styles.progressDivider} />
        {data.progress.map((item, index) => (
          <ProgressStatusRow
            key={item.key}
            item={item}
            total={data.totalIndicators}
            isLast={index === data.progress.length - 1}
          />
        ))}
      </View>

      <ReportGoodNewsCarousel
        indicatorData={data.carouselData}
        mode="materials"
      />

      <View style={styles.card}>
        <SectionHeading
          Icon={Heart2Icon}
          title="Kompetensi Unggulan"
          actionLabel="Lihat Semua"
          onAction={() => setCompetenciesOpen(true)}
        />
        <View style={styles.divider} />
        {data.featuredCompetencies.map((item) => (
          <CompetencyScoreRow key={item.name} item={item} />
        ))}
      </View>

      <TopIndicators items={data.topIndicators} onSeeAll={openAllIndicators} />

      <ReportModalSheet
        visible={competenciesOpen}
        onClose={() => setCompetenciesOpen(false)}
        contentStyle={styles.competenciesSheet}
        Icon={Heart2Icon}
        title="Kompetensi Unggulan"
      >
        <ScrollView
          style={styles.sheetList}
          showsVerticalScrollIndicator={false}
        >
          {data.featuredCompetencies.length ? (
            data.featuredCompetencies.map((item) => (
              <CompetencyScoreRow key={item.name} item={item} />
            ))
          ) : (
            <Text style={styles.sheetEmptyText}>
              Belum ada data kompetensi untuk periode ini.
            </Text>
          )}
        </ScrollView>
      </ReportModalSheet>
    </View>
  );
}

const styles = StyleSheet.create({
  content: { gap: 16 },
  card: {
    padding: 14,
    borderRadius: 14,
    backgroundColor: "#FFFFFF",
    elevation: 2,
    shadowColor: "#34234A",
    shadowOpacity: 0.08,
    shadowRadius: 5,
    shadowOffset: { width: 0, height: 2 },
  },
  divider: {
    height: 1,
    marginTop: 10,
    marginBottom: 5,
    backgroundColor: "#EEEEEE",
  },
  competenciesSheet: { height: "76%" },
  sheetList: { flex: 1 },
  sheetEmptyText: {
    paddingVertical: 16,
    color: "#777777",
    fontFamily: "Archivo-Regular",
    fontSize: 11,
    textAlign: "center",
  },
  sectionHeading: {
    minHeight: 26,
    flexDirection: "row",
    alignItems: "center",
    gap: 8,
  },
  iconTile: {
    width: 28,
    height: 28,
    borderRadius: 6,
    backgroundColor: "#F0E9FF",
    alignItems: "center",
    justifyContent: "center",
  },
  sectionTitle: {
    flex: 1,
    color: "#171717",
    fontFamily: "Archivo-Bold",
    fontSize: 13,
  },
  actionBadge: {
    paddingHorizontal: 10,
    paddingVertical: 6,
    borderRadius: 18,
    backgroundColor: "#F0E9FF",
  },
  actionLabel: { color: "#6724E2", fontFamily: "Archivo-Regular", fontSize: 9 },
  summaryRow: {
    minHeight: 47,
    flexDirection: "row",
    alignItems: "center",
    gap: 10,
  },
  summaryIcon: {
    width: 34,
    height: 34,
    borderRadius: 6,
    backgroundColor: "#000000",
    alignItems: "center",
    justifyContent: "center",
  },
  summaryLabel: {
    flex: 1,
    color: "#171717",
    fontFamily: "Archivo-Regular",
    fontSize: 12,
  },
  summaryValue: {
    minWidth: 48,
    paddingHorizontal: 10,
    paddingVertical: 5,
    borderRadius: 6,
    backgroundColor: "#F0E9FF",
    color: "#5423B5",
    fontFamily: "Archivo-Bold",
    fontSize: 13,
    textAlign: "center",
  },
  progressDivider: {
    height: 1,
    marginTop: 8,
    marginBottom: 4,
    backgroundColor: "#E7E7E7",
  },
  progressRow: {
    minHeight: 58,
    paddingVertical: 6,
    flexDirection: "row",
    alignItems: "center",
    gap: 8,
    borderBottomWidth: StyleSheet.hairlineWidth,
    borderBottomColor: "#E5E5E5",
    borderStyle: "dashed",
  },
  lastProgressRow: { borderBottomWidth: 0 },
  progressStatusIcon: {
    width: 34,
    height: 34,
    borderRadius: 6,
    alignItems: "center",
    justifyContent: "center",
  },
  progressCopy: { flex: 1, gap: 2 },
  progressLabel: {
    color: "#171717",
    fontFamily: "Archivo-Regular",
    fontSize: 11,
  },
  progressCount: { color: "#111111", fontFamily: "Archivo-Bold", fontSize: 14 },
  progressPercentage: {
    color: "#999999",
    fontFamily: "Archivo-Regular",
    fontSize: 13,
  },
  progressTrack: {
    width: 86,
    height: 10,
    borderRadius: 6,
    backgroundColor: "#F0F0F0",
    overflow: "hidden",
  },
  progressFill: { height: "100%", borderRadius: 6 },
  competencyScoreRow: {
    minHeight: 52,
    flexDirection: "row",
    alignItems: "center",
    gap: 12,
  },
  competencyCopy: { flex: 1 },
  competencyName: {
    color: "#5423B5",
    fontFamily: "Archivo-Bold",
    fontSize: 12,
  },
  competencyCount: {
    marginTop: 2,
    color: "#999999",
    fontFamily: "Archivo-Regular",
    fontSize: 11,
  },
  competencyScoreColumn: { width: "32%", alignItems: "flex-end", gap: 3 },
  competencyPercentage: {
    color: "#48B920",
    fontFamily: "Archivo-Bold",
    fontSize: 12,
  },
  competencyTrack: {
    width: "100%",
    height: 12,
    borderRadius: 6,
    backgroundColor: "#EAEAEA",
    overflow: "hidden",
  },
  competencyFill: {
    height: "100%",
    borderRadius: 6,
    backgroundColor: "#48B920",
  },
  segments: { flexDirection: "row", gap: 8, marginTop: 12, marginBottom: 4 },
  segment: {
    position: "relative",
    minHeight: 52,
    flex: 1,
    paddingHorizontal: 8,
    borderWidth: 1,
    borderColor: "#E7E7E7",
    borderRadius: 9,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    gap: 8,
  },
  bestSegmentActive: { borderColor: "#48B920" },
  supportSegmentActive: { borderColor: "#E24B4B" },
  segmentText: {
    color: "#252525",
    fontFamily: "Archivo-Regular",
    fontSize: 11,
    lineHeight: 14,
  },
  bestSegmentText: { color: "#48B920" },
  supportSegmentText: { color: "#D84343" },
  segmentUnderline: {
    position: "absolute",
    left: 16,
    right: 16,
    bottom: 1,
    height: 4,
    borderRadius: 3,
  },
  bestUnderline: { backgroundColor: "#48B920" },
  supportUnderline: { backgroundColor: "#D84343" },
  topIndicatorRow: {
    paddingVertical: 10,
    borderBottomWidth: StyleSheet.hairlineWidth,
    borderBottomColor: "#EEEEEE",
    borderStyle: "dashed",
  },
  lastTopIndicatorRow: { borderBottomWidth: 0 },
  topIndicatorChips: {
    flexDirection: "row",
    alignItems: "center",
    flexWrap: "wrap",
    gap: 6,
  },
  topCategoryChip: {
    minHeight: 24,
    paddingHorizontal: 8,
    borderRadius: 6,
    backgroundColor: "#F1F1F1",
    flexDirection: "row",
    alignItems: "center",
    gap: 6,
  },
  topCategoryText: {
    color: "#555555",
    fontFamily: "Archivo-Regular",
    fontSize: 10,
  },
  topStatusChip: {
    minHeight: 24,
    paddingHorizontal: 8,
    borderRadius: 5,
    flexDirection: "row",
    alignItems: "center",
    gap: 5,
  },
  bestStatusChip: { backgroundColor: "#DDF3D5" },
  supportStatusChip: { backgroundColor: "#FFE0E0" },
  topStatusText: {
    color: "#48B920",
    fontFamily: "Archivo-Regular",
    fontSize: 10,
    textTransform: "uppercase",
  },
  supportStatusText: { color: "#D84343" },
  topIndicatorDescription: {
    marginTop: 8,
    marginLeft: 2,
    color: "#1F1F1F",
    fontFamily: "Archivo-Regular",
    fontSize: 11,
    lineHeight: 16,
  },
  indicatorRow: {
    paddingVertical: 10,
    borderBottomWidth: StyleSheet.hairlineWidth,
    borderBottomColor: "#EEEEEE",
    borderStyle: "dashed",
  },
  lastIndicatorRow: { borderBottomWidth: 0 },
  chipRow: {
    flexDirection: "row",
    alignItems: "center",
    flexWrap: "wrap",
    gap: 6,
  },
  characterChip: {
    minHeight: 24,
    paddingHorizontal: 8,
    borderRadius: 6,
    backgroundColor: "#F1F1F1",
    flexDirection: "row",
    alignItems: "center",
    gap: 6,
  },
  chipText: { color: "#555555", fontFamily: "Archivo-Regular", fontSize: 10 },
  statusChip: {
    minHeight: 24,
    paddingHorizontal: 8,
    borderRadius: 5,
    flexDirection: "row",
    alignItems: "center",
    gap: 5,
  },
  consistent: { backgroundColor: "#DDF3D5" },
  sometimes: { backgroundColor: "#FFF0C8" },
  missing: { backgroundColor: "#FFE0E0" },
  statusText: {
    color: "#48B920",
    fontFamily: "Archivo-Regular",
    fontSize: 10,
    textTransform: "uppercase",
  },
  alertChip: {
    width: 24,
    height: 24,
    borderRadius: 5,
    alignItems: "center",
    justifyContent: "center",
  },
  valueChip: {
    minHeight: 22,
    alignSelf: "flex-start",
    marginTop: 7,
    paddingHorizontal: 8,
    borderRadius: 5,
    backgroundColor: "#F1F1F1",
    flexDirection: "row",
    alignItems: "center",
    gap: 5,
  },
  valueText: { color: "#555555", fontFamily: "Archivo-Regular", fontSize: 10 },
  compactRow: {
    paddingVertical: 10,
    borderBottomWidth: StyleSheet.hairlineWidth,
    borderBottomColor: "#EEEEEE",
  },
  row: {
    paddingVertical: 11,
    borderBottomWidth: StyleSheet.hairlineWidth,
    borderBottomColor: "#EAEAEA",
    borderStyle: "dashed",
  },
  lastRow: { borderBottomWidth: 0 },
  name: {
    color: "#191919",
    fontFamily: "Archivo-Regular",
    fontSize: 11,
    lineHeight: 16,
  },
  compactName: {
    marginTop: 8,
    marginLeft: 2,
    color: "#1F1F1F",
    fontFamily: "Archivo-Regular",
    fontSize: 11,
    lineHeight: 16,
  },
  chipRow: {
    flexDirection: "row",
    alignItems: "center",
    flexWrap: "wrap",
    gap: 6,
  },
  indicatorChip: {
    minHeight: 24,
    paddingHorizontal: 8,
    borderRadius: 6,
    backgroundColor: "#F1F1F1",
    flexDirection: "row",
    alignItems: "center",
    gap: 6,
  },
  chipText: { color: "#555555", fontFamily: "Archivo-Regular", fontSize: 10 },
  statusChip: {
    minHeight: 24,
    paddingHorizontal: 8,
    borderRadius: 5,
    flexDirection: "row",
    alignItems: "center",
    gap: 5,
  },
  statusPill: {
    minHeight: 22,
    alignSelf: "flex-start",
    marginTop: 7,
    paddingHorizontal: 8,
    borderRadius: 5,
    flexDirection: "row",
    alignItems: "center",
    gap: 5,
  },
  statusText: { fontFamily: "Archivo-Regular", fontSize: 10 },
  alertChip: {
    width: 24,
    height: 24,
    borderRadius: 5,
    alignItems: "center",
    justifyContent: "center",
  },
  consistent: { backgroundColor: "#DDF3D5" },
  sometimes: { backgroundColor: "#FFF0C8" },
  missing: { backgroundColor: "#FFE0E0" },
  neutral: { backgroundColor: "#F1F1F1" },
});
